const QA_FEATURE = 'QA'
const QA_SUBJECT = 'QA'

export function canOpenQuality(features: string[]): boolean {
  return features.includes(QA_FEATURE)
}

export function canAssignQuality(
  can: (action: string, subject: string) => boolean,
): boolean {
  return can('assign', QA_SUBJECT)
}

export function canViewQualityOverview(
  can: (action: string, subject: string) => boolean,
): boolean {
  return ['assign', 'viewOrganization', 'viewTeam'].some((action) =>
    can(action, QA_SUBJECT),
  )
}

export function qualityDefaultRoute(
  can: (action: string, subject: string) => boolean,
):
  | 'QualityMyReviews'
  | 'QualityOverview'
  | 'QualityCases'
  | 'QualityCaseFinalization'
  | 'QualityResults'
  | 'QualityScorecards' {
  if (canViewQualityOverview(can)) {
    return 'QualityOverview'
  }

  if (can('review', QA_SUBJECT)) {
    return 'QualityMyReviews'
  }

  if (can('assign', QA_SUBJECT)) {
    return 'QualityCases'
  }

  if (can('finalize', QA_SUBJECT)) {
    return 'QualityCaseFinalization'
  }

  if (can('configure', QA_SUBJECT)) {
    return 'QualityScorecards'
  }

  return 'QualityResults'
}
